<script>
import { isPlainObject } from '../../../../helpers/common';

export default {
    props: {
        name: {
            type: String
        },
        isReadyOnMounted: {
            type: Boolean,
            default: true
        },
        indexDataKey: {
            type: String
        }
    },
    data() {
        return {
            isReady: false,
            index: null,
            indexGrouped: null
        };
    },
    watch: {
        changedByUserInput: function(newValue) {
            this.onChangedByUserInputUpdated(newValue);
        }
    },
    created() {
        // parse name and set this.baseName and this.subNames
        Object.assign(this, this.parseName(this.name));

        // add data processing for unnamed parent
        this.addDataProcessor(this.setUnnamedParentsData, 'set');

        if(this.indexDataKey) {
            // add data processing for indexing
            this.addDataProcessor(this.setIndex, 'get');
        }

        // get parent editable
        this._editableParent = this.getEditableParent();

        if(this._editableParent) {
            // emit childCreated to parent editable
            this._editableParent.$emit('childCreated', this);
        }
    },
    mounted() {
        if(this.isReadyOnMounted) {
            this.ready();
        }
    },
    destroyed() {
        this.$emit('destroyed', this);
    },
    computed: {
        namePath() {
            return [ this.baseName ].concat(this.subNames.length ? this.subNames : []);
        },
        parentEditable() {
            return this._editableParent;
        }
    },
    methods: {
        ready() {
            this.isReady = true;
            this.$emit('ready', this);
        },
        getEditableParent() {
            let parentEditable = null;

            if(this.$parent) {
                let parent = this.$parent;

                while(parent) {
                    if(parent._props && ('hasEditableChildren' in parent._props)) {
                        parentEditable = parent;
                        break;
                    }
                    parent = parent.$parent;
                }
            }

            return parentEditable;
        },
        parseName(name) {
            if(name == undefined || name.indexOf('[') === -1) {
                return { baseName: name, subNames: [] };
            }

            let getSubNamesRegex = /\[([^\]]+)\]/g;
            let baseName,
                subNames = [],
                matches;

            while((matches = getSubNamesRegex.exec(name)) !== null) {
                if(!baseName) {
                    baseName = name.substr(0, getSubNamesRegex.lastIndex - matches[0].length);
                }
                subNames.push(matches[1]);
            }

            return {
                baseName: baseName,
                subNames: subNames
            }
        },
        setUnnamedParentsData(newData) {
            if(this._unnamedEditableParent) {
                let parentData = {};
                parentData[this.baseName] = this.getData(newData);
                this._unnamedEditableParent.setData(parentData, true, false);
            }

            return newData;
        },
        setIndex(newData) {
            let data = newData;

            if(!isPlainObject(newData)) {
                data = {};
                data[this.formDataName] = newData;
            }

            data[this.indexDataKey] = this.index;

            return data;
        },
        onChangedByUserInputUpdated(newValue) {
            this.bubbleUpChangedByUserInput(newValue);
        },
        bubbleUpChangedByUserInput(newValue) {
            if(this.parentEditable) {
                this.parentEditable.changedByUserInput = newValue;
            }
        }
    }
}
</script>